export const CONFIRMED_MENU = "CONFIRMED_MENU";
export const PENDING_MENU = "PENDING_MENU";
export const CANCELLED_MENU = "CANCELLED_MENU";

export const CONFIRMED_LOGO = "check";
export const PENDING_LOGO = "clock";
export const CANCELLED_LOGO = "x";

export const CONFIRMED_COLOR = "green";
export const PENDING_COLOR = "orange";
export const CANCELLED_COLOR = "red";

export const ADD_RESERVATION_LOGO = "add to calendar";
export const ADD_RESERVATION_COLOR = "blue";

export const MANAGE_SHIFT_ICON = "ban";

export const RESERVATION_ICON = "calendar";
export const SEATS_ICON = "food";

export const USER_ICON = "user";

export const CLEAR_INPUT_LOGO = "delete";

export const CALENDAR_LOGO = "calendar alternate";
export const CALENDAR_COLOR = "red";

export const HISTORY_LOGO = "history";
export const HISTORY_COLOR = "purple";

export const VIEW_RESERVATION_LOGO = "eye";
export const VIEW_RESERVATION_COLOR = "blue";

export const PREVIOUS_DAY_LOGO = "angle left";
export const NEXT_DAY_LOGO = "angle right";

export const UI_ICONS = {
    ADD_RESERVATION: "fas fa-calendar-plus",
    LIST_VIEW: "fas fa-list",
    TIMELINE_VIEW: "fas fa-table",
    FLOORPLAN_VIEW: "fas fa-map",
    MANAGE_SHIFTS: "fas fa-ban",
    REFRESH: "fas fa-refresh",
    SEARCH: "fas fa-search",
};

export const GUEST_CHART_COLORS = [
    "#5e4fa2",
    "#3288bd",
    "#66c2a5",
    "#abdda4",
    "#e6f598",
    "#fee08b",
    "#fdae61",
    "#f46d43",
    "#d53e4f",
    "#9e0142",
];

export const TIMELINE_ITEMS_COLORS = [
    'red', 'blue', 'pink', 'olive', 'orange', 'yellow', 'green', 'teal', 'violet', 'purple', 'brown', 'grey', 'black'
];

export const CHART_COLORS = [
    'cornflowerblue', 'darkgreen', 'blue', 'olive', 'orange', 'yellowgreen', 'green', 'teal', 'violet', 'purple', 'brown', 'grey', 'black'
];

export const FLOORPLAN_ITEMS_COLORS = [
    'cornflowerblue', 'darkgreen', 'blue', 'olive', 'orange', 'yellowgreen', 'green', 'teal', 'violet', 'purple', 'brown', 'grey', 'black'
];

export const TIMELINE_ITEMS_SUFFIXES = [
    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm',
    'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'
];

export const GO_BACK_LOGO = "arrow left";

// CUSTOMERS
// UI
export const ADD_CUSTOMER_LOGO = "add user";
export const ADD_CUSTOMER_COLOR = "blue";
export const SEND_EMAIL_TO_CUSTOMER_LOGO = "mail";
export const SEND_EMAIL_TO_CUSTOMER_COLOR = "orange";
export const DOWNLOAD_CUSTOMERS_FILE_LOGO = "file-csv";
export const MANAGE_DUPLICATES_LOGO = "users";
export const DELETE_CUSTOMERS_LOGO = "user delete";

// DAYS
export const WEEKDAYS = [
    "common:weekdays.monday", "common:weekdays.tuesday", "common:weekdays.wednesday", "common:weekdays.thursday", "common:weekdays.friday", "common:weekdays.saturday", "common:weekdays.sunday",
]

// MONTHS

export const JANUARY_TEXT = "common:months.january";
export const FEBRUARY_TEXT = "common:months.february";
export const MARCH_TEXT = "common:months.march";
export const APRIL_TEXT = "common:months.april";
export const MAY_TEXT = "common:months.may";
export const JUNE_TEXT = "common:months.june";
export const JULY_TEXT = "common:months.july";
export const AUGUST_TEXT = "common:months.august";
export const SEPTEMBER_TEXT = "common:months.september";
export const OCTOBER_TEXT = "common:months.october";
export const NOVEMBER_TEXT = "common:months.november";
export const DECEMBER_TEXT = "common:months.december";

export const MONTHS = [
    JANUARY_TEXT,
    FEBRUARY_TEXT,
    MARCH_TEXT, APRIL_TEXT,
    MAY_TEXT,
    JUNE_TEXT,
    JULY_TEXT,
    AUGUST_TEXT,
    SEPTEMBER_TEXT,
    OCTOBER_TEXT,
    NOVEMBER_TEXT,
    DECEMBER_TEXT,
]

export const MONTHS_OPTIONS = MONTHS.map((month, i) => ({ key: i, text: month, value: i + 1, }));

// SETTINGS
export const RESTAURANT_NAME_TEXT = "Nom du restaurant";
export const RESTAURANT_ADDRESS_TEXT = "Adresse du restaurant";

// TIME CONSTANTS
/** Time slice duration in minutes. */
export const TIME_SLICE = 15;
/** Time format, e.g. "14:30:00". */
export const TIME_FORMAT = "HH:mm:ss";
/** Date format, e.g. "2026-09-02". */
export const DATE_FORMAT = "YYYY-MM-DD";
/** Date and time format, e.g. "2026-09-02 14:30:00". */
export const DATETIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;

/** Weekday display format, e.g. "Wed". */
export const DISPLAY_WEEKDAY_FORMAT = "ddd";
/** Full weekday display format, e.g. "Wednesday". */
export const DISPLAY_FULL_WEEKDAY_FORMAT = "dddd";
/** Date display format, e.g. "02/09/2026". */
export const DISPLAY_DATE_FORMAT = "L";
/** Long date display format, e.g. "2 September 2026". */
export const DISPLAY_LONG_DATE_FORMAT = "D MMMM YYYY";
/** Time display format, e.g. "14:30". */
export const DISPLAY_TIME_FORMAT = "LT";
/** Date and time display format, e.g. "Wed, 2 Sep 2026 14:30". */
export const DISPLAY_DATETIME_FORMAT = "llll";
/** Full date and time display format, e.g. "Wednesday, 2 September 2026 14:30". */
export const DISPLAY_FULL_DATETIME_FORMAT = "LLLL";
/** Full day display format, e.g. "Wednesday 2 September 2026". */
export const DISPLAY_DAY_FORMAT = "dddd D MMMM YYYY";
/** Month display format, e.g. "September 2026". */
export const DISPLAY_MONTH_FORMAT = "MMMM YYYY";

export const TIME_SYNC_INTERVAL = 1; // in minutes

export const DEFAULT_HIGHLIGHT_COUNTRIES = ['BE', 'FR', 'NL', 'DE', 'LU', 'IT', 'ES', 'GB', 'US', 'CH', 'IE'];


// WEBPACK FOOTER //
// ./src/constants/ui.js